export class HandlingUnitNotificationsLoad {
  public static readonly type = '[HandlingUnitNotifications] Load Notifications';
  constructor(
    public payload: {
      deliveryNoteNumber: string;
      handlingUnitNumber: string;
    },
  ) {}
}

export class HandlingUnitNotificationsInitialState {
  public static readonly type = '[HandlingUnitNotifications] Set Initial State';
}
